var map = {
	"./partner1.jpg": 4933,
	"./partner10.jpg": 63918,
	"./partner11.jpg": 56556,
	"./partner12.jpg": 35274,
	"./partner13.jpg": 9780,
	"./partner14.jpg": 12254,
	"./partner15.jpg": 25788,
	"./partner16.jpg": 9519,
	"./partner17.jpg": 90769,
	"./partner2.jpg": 14998,
	"./partner3.jpg": 83420,
	"./partner4.jpg": 43815,
	"./partner5.jpg": 42493,
	"./partner6.jpg": 10059,
	"./partner7.jpg": 72544,
	"./partner8.jpg": 73736,
	"./partner9.jpg": 48790
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86006;